module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"back":"Back","addCart":"Add to Cart","availability":"Availability","discontinued":"Not available","price":"Price","deliveryDelay":"** Delivery delay","discount":"discount"},"fr":{"back":"Retour","addCart":"Ajouter au panier","availability":"Disponibilité","discontinued":"Non Disponible","price":"Prix","deliveryDelay":"** Délais de Livraison","discount":"rabais"}}')
  delete Component.options._Ctor
}
